const {firestore} = require("../config/firebase");

module.exports = {
  getBadgeForUser: (user, options = null) => {
    if (!user) return 0;
    const values = Object.values(user.tenant_badge || []);
    const valuesOther = Object.values(user.tenant_badge_other || []);
    let totalBadge = (values.length > 0 ? values.map(x => x && x >= 0 && !isNaN(x) ? x : 0).reduce((a, b) => a + b) : 0);
    let totalBadgeOther = (valuesOther.length > 0 ? valuesOther.map(x => x && x >= 0 && !isNaN(x) ? x : 0).reduce((a, b) => a + b) : 0);
    if (options) {
      let update_badge = {tenant_badge_other: {}};
      update_badge.tenant_badge_other[options.tenant_id] = (
        user.tenant_badge_other && !isNaN(user.tenant_badge_other[options.tenant_id]) ?
          user.tenant_badge_other[options.tenant_id] : 0
      );

      if (options.type === "alert") {
        update_badge.tenant_badge_other[options.tenant_id] = update_badge.tenant_badge_other[options.tenant_id] + 1;
        firestore.collection('notifications')
          .doc(user.owner_id)
          .set(update_badge, {merge: true})
          .catch(error => console.log(error));
        totalBadgeOther = totalBadgeOther + 1;
      }
    } else {
      totalBadge = totalBadge + 1;
    }
    totalBadge = totalBadge + totalBadgeOther;
    return totalBadge;
  }
};